import ajax from "@/common/ajax.js";
import { skk_axios as axios } from "../common/ajax";

// 不要删除！！！/**
//  * post
//  * @param {*} data
//  * @returns
//  */
// export const getHomeCompanyInfosss = (data) => {
//   return axios({
//     url: "/api/index/details",
//     method: "post",
//     data,
//   });
// };

// /**
//  * 首页随机展示
//  * @param {*} params
//  * @returns
//  */
// export const rangeCompanyList = (params) => {
//   return axios({
//     url: "/api/index/rangeCompanyList",
//     method: "get",
//     params,
//   });
// };

/* @param {*} params
 * @returns
 */

//企业基本信息获取 （可用来判断四个用户脚色）
export function enterprise(params) {
  let url = "/api/enterprise/index";
  return axios({
    url,
    method: "get",
    params: params,
  });
}

// export function enterprise(data) {
//   return ajax.request.get("/api/enterprise/index",data);
// }

//提交企业基本信息
//action:update 更新，create 创建
//record_id 在变更驳回的时候，点击编辑带着
//action record_id 有字段就填写，没有字段都不用传
export function regBaseInfo(data) {
  return ajax.request.post("/api/enterprise/regBaseInfo", data);
}

//提交企业缓存
export function save(data, flag) {
  return ajax.request.post("/api/enterprise/setCache", {
    data: data,
    flag: flag,
  });
}

export const skk_set_cache = (data) => {
  return axios({
    url: "/api/enterprise/setCache",
    method: "post",
    data,
  });
};

//查企业缓存（判断用户保存过没有，是否有缓存）
export function getSaveStatus(flag) {
  return ajax.request.get("/api/enterprise/getcache?flag=" + flag);
}

//信息登记列表 （判断是否是新用户，列表数组为空，没提交过任何表单）
export function recordList() {
  return ajax.request.get("/api/performance/performanceList");
}

//信息登记表 不良行为记录
export function bad() {
  return ajax.request.get("/api/enterprise/bad");
}

// 获取用户信息
export function getUserInfo() {
  return ajax.request.get("/api/account/getAccountInfo");
}

//撤回
export function withdraw(data) {
  return ajax.request.post("/api/enterprise/withdraw", data);
}

//更新登记表
export function refreshCert() {
  return ajax.request.get("/api/enterprise/refreshCertificate");
}

//一进来获取证书接口 获取登记表
export function newCertificate() {
  return ajax.request.get("/api/performance/newCertificate");
}
